import { render, staticRenderFns } from "./StockOrderComponent.vue?vue&type=template&id=9682b7aa&"
import script from "./StockOrderComponent.vue?vue&type=script&lang=js&"
export * from "./StockOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports